var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitchOffline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 25,
    viewBox: "0 0 32 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16605_6255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5703 3.83984C26.7612 3.86386 26.9343 3.97018 27.042 4.13281L31.0146 10.1328C31.0867 10.2417 31.125 10.3694 31.125 10.5V16.5C31.125 17.2768 30.7155 17.9692 30.085 18.4453C29.4582 18.9184 28.6389 19.165 27.8115 19.165H25.7734V19.4902C25.7732 19.8572 25.4763 20.155 25.1094 20.1553H21.1895C20.8225 20.1551 20.5246 19.8572 20.5244 19.4902V19.165H11.2061V19.4902C11.2058 19.8573 10.9081 20.1552 10.541 20.1553H6.62207C6.255 20.1552 5.95725 19.8573 5.95703 19.4902V19.165H3.97266C3.14526 19.165 2.32589 18.9184 1.69922 18.4453C1.06874 17.9692 0.65918 17.2767 0.65918 16.5V10.5C0.65918 10.3695 0.697499 10.2417 0.769531 10.1328L4.74316 4.13281L4.79297 4.06641C4.91825 3.92065 5.10198 3.83513 5.29688 3.83496H26.4873L26.5703 3.83984ZM1.98926 16.5C1.98926 16.7841 2.13811 17.1098 2.50098 17.3838C2.86754 17.6605 3.39561 17.8349 3.97266 17.835H27.8115C28.3888 17.835 28.9175 17.6606 29.2842 17.3838C29.647 17.1098 29.7949 16.7841 29.7949 16.5V11.165H1.98926V16.5ZM7 15.5H5V13.5H7V15.5ZM11 15.5H9V13.5H11V15.5ZM15 15.5H13V13.5H15V15.5ZM19 15.5H17V13.5H19V15.5ZM2.5625 9.83496H29.2227L26.1299 5.16504H5.6543L2.5625 9.83496Z",
    fill: "#545454"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16605_6255"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.7848,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchOffline);
export default __webpack_public_path__ + "static/media/Switch_offline.236b8e9ac9685187d76833e9fb0119a3.svg";
export { ForwardRef as ReactComponent };